import { Box } from '@ltvco/refresh-lib/theme';
import { ChatProvider } from '@ltvco/refresh-lib/v2';
import { Routes, Route, Navigate } from 'react-router-dom';

import { NotFound } from 'routes';

import { VehicleMatchmakerPage } from '../VehicleMatchmaker/VehicleMatchmakerPage';

import { ChatPage } from './ChatPage/ChatPage';
import { ChatPageLayout } from './ChatPage/ChatPageLayout';

export const ChatAIContainer = () => {
  return (
    <Box height="100vh" width="100%">
      <ChatProvider>
        <Routes>
          <Route path="/" element={<Navigate to="chat" replace />} />
          <Route
            path="photo-damage-analyzer/*"
            element={<Navigate to="chat/photo-damage-analyzer" replace />}
          />
          <Route
            path="value-forecaster/*"
            element={<Navigate to="chat/value-forecaster" replace />}
          />
          <Route
            path="repair-cost-estimator/*"
            element={<Navigate to="chat/repair-cost-estimator" replace />}
          />
          <Route
            path="vehicle-matchmaker/*"
            element={
              <ChatPageLayout showChatInput>
                <VehicleMatchmakerPage />
              </ChatPageLayout>
            }
          />
          <Route path="chat/*" element={<ChatPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ChatProvider>
    </Box>
  );
};
